import {Component, Input, OnInit} from '@angular/core';
import {GlobalService} from '../../servicos/global.service';
import {Revision} from 'environments/revision';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Input() absolute = false;
  revision = Revision;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(public globalService: GlobalService) {
  }

  ngOnInit() {
  }

  onRedirecionar() {
    this.globalService.nativeWindow.open('https://www.grupootimiza.com.br/siteOtimiza/inicio');
  }
}